import styled from "styled-components"

export const Table = ({headers, data, errorKey}) => {

    const formatTableValue = (value) => {
        if(typeof value !== 'number') return value;
        const roundedValue = Number(value.toFixed(3));
        if(Number.isInteger(roundedValue)) return String(roundedValue);
        return roundedValue.toFixed(3);
    }

    const hasUnits = headers.some(h => h.unit);
    
    return (
        <StyledTableWrapper>
            <table>
                <colgroup>
                    {headers.map((h) => <col key={h.key} style={{ minWidth: 70 }} />)}
                </colgroup>
                <thead>
                    <tr>
                        {
                            headers.map(h => {
                                if(!hasUnits) return <th key={h.key}>{h.label}</th>;
                                return <th key={h.key} rowSpan={h.unit ? 1 : 2}>{h.label}</th>
                            })
                        }
                    </tr>
                    {
                        hasUnits ? 
                        <tr>
                            {headers.map(h => h.unit ? <th key={h.key + '-unit'}>{h.unit}</th> : null)}
                        </tr>
                        : null
                    }
                </thead>
                <tbody>
                    {
                        data.map((row, i) =>{

                            const isError = errorKey && row?.[errorKey];

                            return (
                                <tr key={i} className={isError ? 'error' : ''}>
                                    {
                                        headers.map(h => <td key={h.key}>{formatTableValue(row[h.key])}</td>)
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </StyledTableWrapper>
    )
}

const StyledTableWrapper = styled.div`
    overflow: auto;

    table
    {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        
        thead
        {
            border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            
            th
            {
                font-size: ${({theme}) => theme.fontSize.md};
                //color: ${({theme}) => theme.colors.mutedForeground};
                padding: 0 ${({theme}) => theme.spacing.sm};
                padding-bottom: ${({theme}) => theme.spacing.sm};
                background: ${({theme}) => theme.colors.accentBackground};
            }

            tr:first-child th:first-child
            {
                border-top-left-radius: ${({theme}) => theme.cornerRadius.sm};
            }

            tr:first-child th:last-child
            {
                border-top-right-radius: ${({theme}) => theme.cornerRadius.sm};
            }
        }
        tbody
        {
            tr.error td
            {
                background: ${({theme}) => theme.colors.errorBackground};
                color: ${({theme}) => theme.colors.errorForeground};
                font-weight: 600;
            }
            td
            {
                border-bottom: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
                text-align: center;
                padding: ${({theme}) => theme.spacing.sm};
            }
            tr:last-child td
            {
                border-bottom: none;
            }
        }
        
    }
`